const translation = {
  transactionDetails: '收支明细',
  billReport: '账单概览',
  scheduledSend: '定时发送',
  planList: '套餐列表',
  createPlan: '创建套餐',
  editPlan: '编辑套餐',
  costBill: '成本账单',
  resourceTop10: '资源消费 Top 10',
  cycleBill: '账单详情',
  monthlyBill: '月度账单',
  annualBill: '年度账单',
  groupedBill: '多维度聚合账单',
  recharge: '充值汇款',
  rechargeDetail: '充值详情',
  rechargeAlert1:
    '充值完成后，如您有未结清账单（欠费），充值资金将优先抵扣未结清账单，剩余资金将保留在您的账户内。您可前往收支明细查看收支详情。',
  rechargeAlert2:
    '充值资金不支持直接开票，需购买资源后，前往 发票管理，根据已经出具的账单申请发票。',
  accountBalance: '账户余额',
  rechargeTip: '充值金额只能用于平台消耗，消耗后才可开具发票',
  orderList: '订单列表',
  usageManagement: '计量管理',
  usageOverview: '用量总览',
  usageAnalysis: '用量分析',
  serialNumber: '流水号',
  availableBalance: '可用余额',
  account: '账户',
  ioType: '收支类型',
  tradeType: '交易类型',
  channel: '交易渠道',
  amount: '金额',
  changeAmount: '变动金额',
  balance: '余额',
  comment: '交易备注',
  commentMaxLength: '备注最多500个字符',
  purchase: '新购',
  channelSerialNumber: '交易渠道流水号',
  tradeTime: '交易时间',
  action: '操作',
  detail: '详情',
  productName: '产品名称',
  productNameRule: '产品名称必须为大小写字母和数字组成',
  productSpec: '产品规格',
  productSpecRule: '产品名称必须为大小写字母、数字、「.」、「/」、「-」组成',
  postPaid: '后付费',
  monthlyPaid: '月付费',
  annualPaid: '年付费',
  modelInPrice: '推理输入价格',
  modelOutPrice: '推理输出价格',
  confirm: '确定',
  cancel: '取消',
  onlineRecharge: '在线充值',
  rechargeAmount: '充值金额',
  inputRechargeAmount: '请输入充值金额',
  rechargeAmountGreaterThanZero: '充值金额必须大于0',
  iHaveRead: '我已了解:',
  createRechargeOrder: '创建充值订单',
  orderId: '订单号',
  type: '订单类型',
  status: '订单状态',
  product: '商品',
  createdAt: '创建时间',
  updatedAt: '更新时间',
  paidAt: '支付时间',
  deletePlan: '删除套餐',
  edit: '编辑',
  delete: '删除',
  postPaidPrice: '后付费价格',
  postPaidBillCycle: '后付费账单周期',
  monthlyPrice: '月付费价格',
  annualPrice: '年付费价格',
  paginationTotal: '第 {start}-{end} 条，共 {total} 条',
  orderSummary: '订单概要',
  orderType: '订单类型',
  payType: '支付方式',
  orderDetailType: '类型',
  prepaid: '预付费',
  postpaid: '后付费',
  name: '名称',
  architecture: '架构',
  preferRegion: 'prefer_region',
  preferZone: 'prefer_zone',
  createOrder: '发起订单',
  userId: '用户ID',
  buyAccount: '产品购买账号',
  payChannel: '支付渠道',
  inputSerialNumber: '请输入流水号',
  filterOrderId: '交易单号',
  inputOrderId: '请输入交易单号',
  inputChannelSerialNumber: '请输入渠道交易流水号',
  startTime: '开始时间',
  endTime: '结束时间',
  selectTradeType: '请选择交易类型',
  search: '搜索',
  reset: '重置',
  channelAlipay: '支付宝',
  channelBalance: '余额',
  unknown: '未知',
  assetId: '商品 ID',
  usage: '用量',
  price: '价格',
  statusMap: {
    running: '运行中',
    paused: '已暂停',
    deleted: '已删除',
    stopped: '已停止',
    unknown: '未知',
  },
  statusPending: '待支付',
  statusCompleted: '已支付',
  statusCancelled: '已取消',
  ioIn: '收入',
  ioOut: '支出',
  tradeRecharge: '充值',
  tradeConsume: '消费',
  tradePostpaid: '按量计费',
  tradePrepaid: '预付费',
  resourceId: '资源 ID',
  resourceType: '资源类型',
  resourceName: '资源名称',
  orderDetail: '订单详情',
  canceledAt: '取消时间',
  projectId: '项目ID',
  payOrder: '支付订单',
  backToList: '返回{{type}}列表',
  vm: '虚拟机',
  baremetal: '裸金属',
  disk: '硬盘',
  productTypes: {
    gpu: 'AI算力',
    vdisk: 'AI存储',
    disk: '块存储',
    ecs: '虚拟机',
    baremetal: '裸金属',
    harbor: '镜像仓库',
  },
  regions: {
    'cn-east-1': '华东1',
    'cn-east-2': '华东2',
    'cn-south-1': '华南1',
    'cn-north-1': '华北1',
    'cn-southwest-1': '西南1',
  },
  orderTagType: {
    RECHARGE: '充值',
    PURCHASE: '消费',
    RENEW: '续费',
    UNSUBSCRIBE: '退订',
  },
  invoiceStatus: {
    PENDING: '待支付',
    COMPLETED: '已支付',
    CANCELLED: '已取消',
  },
  invoice_status: {
    pending: '待支付',
    completed: '已支付',
    cancelled: '已取消',
  },
  trade_type: {
    recharge: '充值',
    consume: '预付费',
    postpaid: '按量计费',
    refund: '退款',
  },
  order_type: {
    recharge: '充值',
    purchase: '消费',
    renew: '续费',
    unsubscribe: '退订',
  },
  io_type: {
    in: '收入',
    out: '支出',
  },
  date: '日期',
  project: '项目',
  billingType: '计费模式',
  region: '区域',
  totalAmount: '总金额',
  month: '月',
  report_user_config_modal: {
    title: '定时发送',
    enable_report: '定时发送报表',
    time_unit: '发送频率',
    time_unit_required: '请选择发送频率',
    time_unit_monthly: '每月',
    time_unit_weekly: '每周',
    time_unit_daily: '每日',
    email: '接收邮箱',
    email_required: '请输入接收邮箱',
    email_placeholder: '请输入接收邮箱',
    confirm: '确认',
  },
  admin_bill_list: {
    title: '订单管理',
    order_id: '订单编号',
    user: '用户',
    order_type: '订单类型',
    amount: '金额',
    balance: '实际金额',
    discount: '（{discount} 折）',
    status: '状态',
    created_at: '创建时间',
    updated_at: '更新时间',
    operations: '操作',
    modify_price: '修改价格',
    cancel_order: '取消订单',
    cancel_order_confirm: '真的要取消订单吗？',
    original_price: '原价',
    discount_price: '折扣价',
    discount_price_required: '请输入折扣价',
    discount_price_placeholder: '请输入折扣价',
    confirm: '确认',
    unknown: '未知',
  },
  admin_coupon_list: {
    title: '代金券管理',
    placeholder: '搜索代金券名称/ID',
    create: '添加代金券',
    alert1:
      '代金券可支付预付费订单或后付费账单费用，但不可抵扣欠费，申请退款时，代金券不支持退还；代金券不支持延期、开票、提现、跨账号使用。',
    alert2:
      '代金券在有效期内才可以被使用，若预付费下单或后付费出账扣券时间未到代金券生效时间或已过代金券失效时间，则代金券不可使用；代金券的有效期不可延长。',
    alert3: '生效中的代金券作废时已生效部分不受影响。',
    id: 'ID',
    nameAndId: '名称 / ID',
    total_amount: '总面额',
    applicable_products: '适用产品',
    payment_method: '付款方式',
    applicable_orders: '适用订单',
    usage_limit: '使用限制',
    validity_period: '有效期',
    status: '状态',
    created_by: '创建人',
    issuer: '发放人',
    created_at: '创建时间',
    issue_time: '发放时间',
    valid_from: '生效时间',
    valid_to: '失效时间',
    updated_at: '更新时间',
    operations: '操作',
    detail: '详情',
    send: '手动发送',
    invalidate: '作废',
    copy: '复制',
    invalidate_confirm_title: '确认作废',
    invalidate_confirm_desc:
      '请确认是否作废该代金券，执行作废后相关用户所有的代金券全部作废且无法恢复，已经执行的代金券不受影响，请谨慎操作。',
    invalidate_success: '作废代金券成功',
    invalidate_failed: '作废代金券失败',
    confirm: '确定',
    cancel: '取消',
    unknown: '未知',
    empty_text: '暂无数据',
    sendCoupon: {
      title: '发送代金券',
      success: '代金券发送成功',
      failed: '发送代金券失败',
      selectUsers: '选择用户',
      selectUsersPlaceholder: '请搜索选择要发送代金券的用户',
      selectUsersRequired: '请选择要发送的用户',
      couponName: '代金券名称',
      couponId: '代金券ID',
    },
    couponStatus: {
      pending: '待生效',
      active: '已生效',
      expired: '已过期',
      voided: '已作废',
      used: '已用完',
      stopped: '已停止',
    },
    all_products: '全部产品',
    part_products: '部分产品',
  },
  coupon: {
    create: {
      title: '创建代金券',
      action: '创建代金券',
    },
    detail: {
      title: '代金券详情',
      basicInfo: '基本信息',
      loading: '加载中...',
      notFound: '代金券不存在',
      user_usage_history: '用户使用记录',
      tabs: {
        basicInfo: '基本信息',
        usageHistory: '使用记录',
      },
    },
    usage: {
      title: '使用记录',
      description: '显示该代金券的所有使用记录',
      userName: '使用账号',
      orderNo: '订单号',
      changeAmount: '变更金额',
      status: '状态',
      statusUsed: '已用完',
      statusRefunded: '已退款',
      usedAt: '时间',
      userID: '用户ID',
      user_name: '用户名称',
    },
    form: {
      basicInfo: {
        title: '基本信息',
        name: '代金券名称',
        namePlaceholder: '请输入代金券名称',
        namePattern: '支持中英文、数字、连字符和下划线，长度3-64',
        amount: '代金券面值',
        amountPlaceholder: '请输入代金券面值',
        amountRequired: '请输入代金券面值',
        amountMin: '面值必须大于0',
        amountMax: '最多支持两位小数',
        validityPeriod: '使用有效期',
        status: '代金券状态',
        validityPeriodRequired: '请选择使用有效期',
        startDate: '开始日期',
        endDate: '结束日期',
      },
      applicableScope: {
        title: '适用范围',
        products: '适用产品',
        productsPlaceholder: '请选择适用产品',
        paymentMethod: '付款方式',
        paymentMethodPlaceholder: '请选择付款方式',
        allPaymentMethods: '所有付款方式',
        prepaid: '预付费',
        postpaid: '后付费',
        orders: '适用订单',
        ordersPlaceholder: '请选择适用订单',
        allOrders: '所有订单',
        newOrders: '新订单',
        existingOrders: '现有订单',
      },
      otherInfo: {
        title: '其他信息',
        usageLimit: '使用限制',
        usageLimitDesc: '满¥0.00可用',
        usageLimitPlaceholder: '请选择使用限制',
        unlimited: '无限制',
        once: '仅限使用一次',
        multiple: '可多次使用',
        notes: '备注',
        notesPlaceholder: '请输入优惠券备注信息，方便管理，不会对用户显示',
      },
      submit: '确定',
      cancel: '取消',
    },
    issuedUsers: '发放用户',
    usageHistory: '使用记录',
  },
  promotion: {
    list: {
      title: '促销活动管理',
      add: '添加促销活动',
      search_placeholder: '搜索促销活动名称/ID',
      search: '搜索',
      table: {
        id: 'ID',
        nameAndId: '名称 / ID',
        promotionType: '促销方式',
        promotionContent: '促销信息',
        allProduct: '适用产品',
        allProduct_all: '全部商品',
        allProduct_part: '部分商品',
        purchaseMethods: '付款方式',
        orderTypes: '适用订单',
        endTime: '有效期 (UTC+8)',
        status: '状态',
        createdBy: '创建人',
        initiator: '活动发起人',
        createdAt: '创建时间',
        action: '操作',
        detail: '详情',
        stop: '停止',
        copy: '复制',
      },
      status: {
        pending: '待生效',
        active: '生效中',
        expired: '已失效',
        stopped: '已停止',
        unknown: '未知',
      },
      stop_modal: {
        title: '停止促销活动',
        content:
          '请确认是否执行停止操作，执行停止操作后无法恢复，已经执行的促销订单不受影响，请谨慎操作。',
        ok: '确定',
        cancel: '取消',
      },
      table_total: '共 {{total}} 条记录',
      alert1:
        '多促销活动机制：单个产品可同时参与多个促销活动，系统将自动计算所有有效促销规则下的价格，并以最低价格作为最终展示价格和销售价格。',
      alert2:
        '一旦某促销活动被停止，系统将自动重新计算商品当前参与的其他促销活动，并根据新的生效规则动态调整价格。若无其他活动生效，则恢复为产品的原始标价。',
      alert3:
        '建议定期检查促销活动的有效性与效果，避免出现多重折扣导致利润侵蚀等。',
      alert4:
        '在促销结束后，建议及时复查产品价格是否已正确修正，确保无遗漏活动影响正常销售。',
    },
    create: {
      title: '添加促销活动',
      action: '创建促销活动',
      form: {
        name: {
          label: '活动名称',
          placeholder: '请输入活动名称',
          extra: '支持中英文数字，中间连字符-，下划线_，长度3-64',
          required: '请输入活动名称',
          length: '活动名称长度应为3-64个字符',
          pattern: '活动名称只能包含中英文、数字、连字符和下划线',
        },
        type: {
          label: '促销方式',
          discount: '限时折扣',
        },
        discount: {
          label: '限时折扣/%',
          placeholder: '请输入折扣',
          extra: '请输入1至99的整数，0代表免费',
          required: '请输入折扣',
          range: '折扣必须大于1小于99',
        },
        validFrom: {
          label: '活动有效期',
        },
        comment: {
          label: '备注',
          placeholder: '请输入活动备注信息，方便管理，不会对用户显示',
          extra: '请输入活动备注信息，方便管理，不会对用户显示',
        },
        submit: '确定',
        cancel: '取消',
      },
      productModal: {
        title: '请选择产品',
        search_placeholder: '请输入产品名称搜索',
        search: '搜索',
        ok: '确定',
        cancel: '取消',
        selected: '已选产品：',
      },
    },
    detail: {
      title: '促销活动详情',
      notFound: '促销活动不存在',
      loading: '加载中...',
      baseInfo: '基本信息',
      id: '活动ID',
      promotionType: '促销方式',
      validPeriod: '活动有效期',
      promotionContent: '促销信息',
      createdBy: '创建人',
      createdAt: '创建时间',
      comment: '备注',
      allProduct: '适用产品',
      allProduct_all: '全部产品',
      allProduct_part: '部分产品',
      free: '免费',
      discountUnit: '折',
    },
    applicableProducts: {
      title: '适用产品',
      table: {
        id: '产品ID',
        name: '产品名称',
        type: '产品类型',
        regions: '可用地区',
        clusters: '资源集群',
        paymentMethods: '付款方式',
        orderTypes: '适用订单',
      },
      total: '共 {{total}} 条',
    },
    applicableScope: {
      productName: '产品名称',
      productTypes: '产品类型',
      productTypes_placeholder: '请选择产品类型',
      productTypes_required: '请选择产品类型',
      regions: '可用地区',
      regions_tips: '模型服务仅适用于默认地区',
      regions_placeholder: '请选择可用地区',
      regions_required: '请选择可用地区',
      clusters: '资源集群',
      clusters_tips: '模型服务仅适用于默认集群',
      clusters_placeholder: '请选择资源集群',
      clusters_required: '请选择资源集群',
      allProduct: '适用产品',
      allProduct_all: '全部产品',
      allProduct_part: '部分产品',
      allProduct_required: '请选择适用产品',
      planIds: '选择可用产品',
      planIds_placeholder: '请选择具体产品',
      planIds_required: '请选择具体产品',
      modelIds: '选择模型',
      modelIds_placeholder: '请选择模型',
      modelIds_required: '请选择模型',
      purchaseMethods: '付款方式',
      purchaseMethods_required: '请选择付款方式',
      purchaseMethods_month: '预付费-包月',
      purchaseMethods_year: '预付费-包年',
      purchaseMethods_post: '后付费',
      purchaseMethods_postTooltip:
        '模型服务只有后付费方式，如果选择了模型服务，则必须勾选后付费，促销活动才能生效。',
      orderTypes: '适用订单',
      orderTypes_required: '请选择适用订单',
      orderTypes_new: '新购',
      orderTypes_newTooltip: '模型服务只支持新购，如果选择了模型服务，则必须勾选后付费，活动才能生效。',
      orderTypes_auto: '自动续费',
      orderTypes_manual: '手动续费',
      modelServiceConflictTip: '模型服务不能与其他产品同时参与促销活动',
    },
  },
  'new-product': {
    title: '产品管理',
    addProduct: '添加产品',
    searchPlaceholder: '请输入产品名称或ID进行搜索',
    resourceTagsLimit: '资源标签最多只能选择3个',
    table: {
      id: 'ID',
      nameAndId: '名称 / ID',
      productType: '产品类型',
      productName: '产品名称',
      availableRegion: '可用地区',
      clusterResource: '集群资源',
      postPaidPrice: '后付费价格',
      postPaidPriceTooltip: '模型服务后付费价格分：推理输入价格和推理输出价格',
      monthlyPrice: '月付费价格',
      annualPrice: '年付费价格',
      sortOrder: '排序序号',
      sortOrderTooltip:
        '排序序号用于确定产品在算力市场中的展示顺序：数值越大，排名越靠前。若序号相同，则按价格由低到高排序。默认值为1，仅可输入正整数。',
      status: '购买状态',
      statusTooltip:
        '"已上架"状态表示【AI算力】产品已对用户开放，用户可在机器学习平台创建容器实例、训练任务或推理服务等任务负载时查看并选择购买使用。对于【模型服务】类产品表示可以在模型广场查看和购买。',
      publishStatus: '发布状态',
      publishStatusTooltip:
        '仅"已上架"状态的产品可发布至算力市场。发布后，该产品将对所有用户可见，并支持购买和使用。',
      published: '已发布',
      unpublished: '未发布',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      action: '操作',
      detail: '详情',
      edit: '编辑',
      online: '上架',
      offline: '下架',
      publish: '发布',
      cancelPublish: '取消发布',
      singlePromotion: '单品促销',
      delete: '删除',
      onlineStatus: '已上架',
      offlineStatus: '已下架',
      pricePerHour: '¥{{price}}/小时',
      pricePerMonth: '¥{{price}}/月',
      pricePerYear: '¥{{price}}/年',
      noPrice: '-',
      disabledEditWarning: '请将产品下架后，再进行编辑',
      disabledPublishWarning: '请将产品上架到机器学习平台后，再发布到算力市场',
      disabledDeleteWarning: '请将产品下架后，再进行删除',
      disabledOnlineWarning: '该产品已经售罄，无法上架',
      cannotPublishWaring: '该产品类型不支持发布到算力市场。',
    },
    modal: {
      delete: {
        title: '删除产品',
        content: '请确认是否删除该产品，执行删除后无法恢复，请谨慎操作。',
        confirm: '确定',
        cancel: '取消',
      },
      offline: {
        title: '下架产品',
        content:
          '请确认是否将该产品下架。产品从机器学习平台下架后，将无法在平台内购买和使用。若该产品已发布至算力市场，下架后也将同步从算力市场下线，不再对用户展示和提供服务。',
        contentModel:
          '下架”【模型服务】后，该模型在模型广场变成免费状态，用户可免费使用，如果下架模型服务请到机器学习平台模型管理进行下线。',
        confirm: '确定',
        cancel: '取消',
      },
      online: {
        title: '上架产品',
        content:
          '请确认是否将该产品上架。"上架"指将产品发布至机器学习平台。产品上架后，用户在机器学习平台创建容器实例、训练任务或推理服务等任务负载时，可查看并选择该产品进行购买和使用。',
        contentModel:
          '“上架”【模型服务】是机器学习平台的模型广场的模型支持按照设定价格售卖。',
        confirm: '确定',
        cancel: '取消',
      },
      publish: {
        title: '发布产品',
        content:
          '请确认是否发布该产品。仅"已上架"状态的产品可发布至算力市场。发布后，该产品将在算力市场对所有用户可见，并支持购买和使用。',
        confirm: '确定',
        cancel: '取消',
      },
      cancelPublish: {
        title: '取消发布产品',
        content:
          '请确认是否取消发布该产品。取消发布产品后，该产品将从算力市场下线。',
        confirm: '确定',
        cancel: '取消',
      },
    },
    message: {
      fetchFailed: '获取产品列表失败，请重试',
      deleteSuccess: '产品删除成功！',
      deleteFailed: '删除失败，请重试',
      onlineSuccess: '产品上架成功！',
      offlineSuccess: '产品下架成功！',
      publishSuccess: '产品发布成功！',
      cancelPublishSuccess: '取消发布成功！',
      operationFailed: '操作失败，请重试',
      soldOutWarning: '库存售罄的产品无法上架，请先补充库存',
      publishFailed: '发布失败，请重试',
      cancelPublishFailed: '取消发布失败，请重试',
    },
    pagination: {
      total: '第 {start}-{end} 条，共 {total} 条',
    },
    detail: {
      title: '产品管理',
      loading: '加载中...',
      productNotFound: '产品不存在',
      productIdRequired: '产品ID不能为空',
      loadProductFailed: '加载产品信息失败',
      basicInfo: '基本信息',
      operationHistory: '产品操作历史',
      promotionHistory: '促销活动历史',
      onlineStatus: '已上架',
      offlineStatus: '未上架',
      publishedStatus: '已发布',
      unpublishedStatus: '未发布',
      detailSuffix: '详情',
      // BasicInfoTab 组件翻译
      basicInfoTab: {
        back: '返回',
        edit: '编辑',
        adjustPrice: '调整价格',
        singlePromotion: '单品促销',
        basicInfo: '基本信息',
        productSpecId: 'ID',
        productName: '产品名称',
        productType: '产品类型',
        status: '上架设置',
        region: '可用地区',
        clusterId: '资源集群',
        productSpec: '产品规格',
        inventoryStatus: '库存状态',
        labels: '资源标签',
        priceInfo: '价格信息',
        hourlyBilling: '按小时计费',
        monthlyBilling: '按月计费',
        annualBilling: '按年计费',
        notSupported: '暂不支持',
        billingCycleConfig: '计费周期配置',
        supportHourlyBilling: '支持按小时计费',
        supportMonthlyBilling: '支持按月计费',
        supportAnnualBilling: '支持按年计费',
        postpaidBillingCycle: '后付费计费周期',
        hourly: '按小时',
        yes: '是',
        no: '否',
        online: '已上架',
        offline: '未上架',
        inventoryType: {
          enough: '充足',
          surging: '紧张',
          soldOut: '缺货',
        },
        priceUnit: {
          perHour: '/小时',
          perMonth: '/月',
          perYear: '/年',
        },
        createdAt: '创建时间',
        updatedAt: '更新时间',
        createdBy: '创建人',
      },
      // OperationHistoryTab 组件翻译
      operationHistoryTab: {
        operator: '操作人',
        postpaidPrice: '后付费价格',
        monthlyPrice: '月付费价格',
        annualPrice: '年付费价格',
        purchaseStatus: '购买状态',
        publishStatus: '发布状态',
        inventoryStatus: '库存状态',
        operationTime: '操作时间',
        online: '已上架',
        offline: '未上架',
        published: '已发布',
        unpublished: '未发布',
        noData: '-',
        inventoryEnough: '资源充足',
        inventorySurging: '资源紧张',
        inventorySoldOut: '已售罄',
      },
      // PromotionHistoryTab 组件翻译
      promotionHistoryTab: {
        activityId: '活动ID',
        activityName: '活动名称',
        promotionType: '促销方式',
        activityDetails: '活动详情',
        originalPrice: '原价',
        paymentMethod: '付款方式',
        applicableOrders: '适用订单',
        validPeriod: '有效期',
        status: '状态',
        initiator: '发起人',
        createTime: '创建时间',
        statusMap: {
          pending: '待生效',
          active: '生效中',
          inactive: '已失效',
        },
        promotionTypeMap: {
          discount: '限时折扣',
          directReduction: '直减',
          freeTrial: '免费试用',
          memberPrice: '会员价',
        },
        free: '免费',
      },
    },
    edit: {
      title: '产品管理/编辑产品',
      loading: '加载中...',
      productNotFound: '产品不存在',
      productIdRequired: '产品ID不能为空',
      loadProductFailed: '加载产品信息失败',
      updateSuccess: '产品信息更新成功！',
      updateFailed: '更新失败，请重试',
      form: {
        productType: '产品类型',
        productTypeRequired: '请选择产品类型',
        productTypePlaceholder: '请选择产品类型',
        region: '可用地区',
        regionRequired: '请选择可用地区',
        regionPlaceholder: '请选择可用地区',
        clusterResource: '集群资源',
        clusterResourceRequired: '请选择集群资源',
        clusterResourcePlaceholder: '请选择集群资源',
        productSpec: '产品名称',
        productSpecRequired: '请选择产品名称',
        productSpecPlaceholder: '请选择产品名称',
        priceSettings: '原始价格',
        postPaid: '后付费',
        postPaidPrice: '请输入价格',
        postPaidUnit: '/小时',
        monthlyPaid: '月付费',
        monthlyPrice: '请输入价格',
        monthlyUnit: '/月',
        modelUnit: '/百万 tokens',
        modelInPrice: '推理输入价格',
        modelOutPrice: '推理输出价格',
        modelInPriceRequired: '请输入推理输入价格',
        modelOutPriceRequired: '请输入推理输出价格',
        input: '输入',
        output: '输出',
        annualPaid: '年付费',
        annualPrice: '请输入价格',
        annualUnit: '/年',
        onlineSettings: '上架设置',
        onlineSettingsDesc:
          '“上架”指将产品发布至机器学习平台。产品上架后，用户在机器学习平台创建容器实例、训练任务或推理服务等任务负载时，可查看并选择该产品进行购买和使用。',
        online: '开启',
        offline: '关闭',
        stockStatus: '库存状态',
        stockStatusEnough: '资源充足',
        stockStatusSurging: '资源紧张',
        stockStatusSoldOut: '已售罄',
        resourceTags: '资源标签',
        resourceTagsGeneral: '通用型',
        resourceTagsCompute: '计算型',
        resourceTagsMemory: '内存型',
        resourceTagsHighPerformance: '高性能',
        resourceTagsSpecialOffer: '特惠',
        customTag: '自定义标签',
        customTagPlaceholder: '请输入标签名称',
        addCustomTag: '+ 自定义标签',
        addCustomTagSuccess: '标签添加成功！',
        addCustomTagFailed: '添加标签失败，请重试',
        customTagTitle: '添加自定义标签',
        sortOrder: '排序序号',
        sortOrderPlaceholder: '请输入排序序号',
        postPaidPriceRequired: '请输入后付费价格或取消勾选后付费选项',
        monthlyPriceRequired: '请输入月付费价格或取消勾选月付费选项',
        annualPriceRequired: '请输入年付费价格或取消勾选年付费选项',
      },
      buttons: {
        cancel: '取消',
        confirm: '确定',
      },
    },
    create: {
      title: '产品管理/添加产品',
      form: {
        productType: '产品类型',
        productTypeRequired: '请选择产品类型',
        productTypePlaceholder: '请选择产品类型',
        region: '可用地区',
        regionRequired: '请选择可用地区',
        regionPlaceholder: '请选择可用地区',
        clusterResource: '集群资源',
        clusterResourceRequired: '请选择集群资源',
        clusterResourcePlaceholder: '请选择集群资源',
        productSpec: '产品名称',
        productSpecRequired: '请选择产品名称',
        productSpecPlaceholder: '请选择产品名称',
        priceSettings: '原始价格',
        postPaid: '后付费',
        postPaidPrice: '请输入价格',
        postPaidUnit: '/小时',
        monthlyPaid: '月付费',
        monthlyPrice: '请输入价格',
        monthlyUnit: '/月',
        modelUnit: '/百万 tokens',
        modelInPrice: '推理输入价格',
        modelOutPrice: '推理输出价格',
        input: '输入',
        output: '输出',
        modelInPriceRequired: '请输入推理输入价格',
        modelOutPriceRequired: '请输入推理输出价格',
        annualPaid: '年付费',
        annualPrice: '请输入价格',
        annualUnit: '/年',
        onlineSettings: '上架设置',
        onlineSettingsDesc:
          '“上架”指将产品发布至机器学习平台。产品上架后，用户在机器学习平台创建容器实例、训练任务或推理服务等任务负载时，可查看并选择该产品进行购买和使用。',
        online: '开启',
        offline: '关闭',
        stockStatus: '库存状态',
        stockStatusEnough: '资源充足',
        stockStatusSurging: '资源紧张',
        stockStatusSoldOut: '已售罄',
        resourceTags: '资源标签',
        resourceTagsGeneral: '通用型',
        resourceTagsCompute: '计算型',
        resourceTagsMemory: '内存型',
        resourceTagsHighPerformance: '高性能',
        resourceTagsSpecialOffer: '特惠',
        customTag: '自定义标签',
        customTagPlaceholder: '请输入标签名称',
        addCustomTag: '+ 自定义标签',
        addCustomTagSuccess: '标签添加成功！',
        addCustomTagFailed: '添加标签失败，请重试',
        customTagTitle: '添加自定义标签',
        sortOrder: '排序序号',
        sortOrderPlaceholder: '请输入排序序号',
      },
      buttons: {
        cancel: '取消',
        confirm: '确定',
      },
      message: {
        createSuccess: '产品信息创建成功！',
        createFailed: '创建失败，请重试',
      },
    },
  },
  transactionHistory: {
    title: '充值历史',
    paymentMethod: '支付方式',
    status: '状态',
    amount: '金额',
    createdAt: '创建时间',
    paidAt: '支付时间',
    account: '充值账户',
    action: '操作',
    paymentMethodMap: {
      alipay: '支付宝',
      wechat: '微信支付',
      balance: '余额',
      bankCard: '银行卡',
    },
  },
  adminRecharge: {
    title: '用户余额',
    table: {
      nameAndId: '用户名 / ID',
      balance: '余额',
      quota: '欠费限额',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      action: '操作',
      recharge: '充值',
      quotaConfig: '限额',
    },
    form: {
      user: '用户',
      balance: '余额',
      rechargeAmount: '充值金额',
      rechargeAmountPlaceholder: '充值金额',
      rechargeAmountRequired: '请输入充值金额',
      rechargeAmountGreaterThanZero: '充值金额必须大于0',
      contractNo: '合同编号',
      contractNoPlaceholder: '请输入合同编号',
      comment: '备注信息',
      commentPlaceholder: '请输入备注信息',
      commentRequired: '请输入备注信息',
      quota: '欠费限额',
      quotaPlaceholder: '欠费限额',
      submit: '提交',
    },
    modal: {
      recharge: '充值',
      quotaConfig: '欠费限额配置',
    },
  },
  cost_report: {
    alert1:
      '成本账单提供了费用分摊能力，将您的资源费用按照指定分摊规则分摊至自然月，包含预付费分摊数据和后付费账单数据。',
    alert2:
      '成本账单的账务账期：被分摊的费用账单归属的账务账期；如在1月下单购买包年1年的算力资源，原始费用账单归属账务账期为1月，成本账单可按照资源实际使用周期分摊至1-12月的各分摊月。',
    alert3:
      '费用成本支持按照资源类型、可用地区、项目、计费模式等多种筛选和分类，支持可视化展示费用账单的消费趋势和费用组成结构。',
  },
  usage_report: {
    alert1:
      '资源用量为用户提供一个全面、直观的视图，以监控和分析其在平台上的计算资源、存储资源使用情况以及任务的负载明细。',
    alert2:
      '方便用户清晰地看到计算和存储资源的使用量、使用趋势，帮助用户识别资源消耗的主要来源，进而优化资源配置，降低成本。',
    alert3:
      '基于详细的资源使用数据，用户可以做出更明智的资源分配和预算规划决策。',
  },
  cycle: {
    hourly: '每时',
    daily: '每天',
    weekly: '每周',
    monthly: '每月',
    yearly: '每年',
  },
  cycleFilter: {
    billingPeriod: '账期',
    startDate: '开始日期',
    endDate: '结束日期',
  },
  defaultClusters: {
    clusterA: '集群A',
    clusterB: '集群B',
    clusterC: '集群C',
    clusterD: '集群D',
  },
}

export default translation
